export default __webpack_public_path__ + "static/media/siding-icon.ec370f5a.svg";